<script lang="ts">
	import Seo from '$lib/components/SEO.svelte';
	import { Button } from '$lib/components/ui/button/index.js';
	import image from '$lib/assets/images/error.jpg';
	import { onMount } from 'svelte';
	let animate = false;

	onMount(() => {
		setTimeout(() => {
			window.scrollTo(0, 0);
		}, 200);
		animate = true;
	});
</script>

<Seo
	title="Page not Available - Tassie Tours"
	description="Day tours from Hobart, Discover Bruny Island, Cradle Mountain, Active Tasmania tours great for backpackers and people looking for adventure. Book today."
	keywords="Tasmania Tours, Tasmania local tour, Tassie Tours, Day tours from Hobart, Discover Bruny Island, Cradle Mountain, Active Tasmania tours"
	siteName="Tassie Tours"
	imageURL="/images/hero-carousel-1.jpg"
	logo="/logo/logo-black.png"
	author="Tassie Tours"
	type="website"
	name="Tassie Tours"
	index={false}
	twitter={true}
	openGraph={true}
	schemaOrg={true}
/>

<div class="h-screen w-full lg:grid lg:min-h-[600px] lg:grid-cols-2 xl:min-h-[800px]">
	<div class="flex h-screen items-center justify-center py-12">
		<div class="mx-auto grid w-[350px] gap-6">
			<div class="grid gap-2 text-center">
				<div class="flex w-full items-center justify-center pb-4">
					<enhanced:img
						src="/src/lib/assets/logo/logo-black.png"
						alt="Tassie Tours Logo"
						class="h-24 w-auto"
					/>
				</div>
				<h1 class="font-heading text-3xl font-bold">Page not available...</h1>
				<p class="text-balance text-muted-foreground">Choose one of the links below.</p>
			</div>
			<div class="grid gap-4">
				<Button href="/" class="w-full rounded-full bg-tt-red hover:bg-tt-red/85">Go home</Button>
				<Button href="/tours" variant="outline" class="w-full rounded-full">View all tours</Button>
			</div>
			<div class="mt-4 text-center text-sm">
				Have a question?
				<a href="/contact" class="underline"> Get in touch </a>
			</div>
		</div>
	</div>
	<div class="hidden bg-muted lg:block">
		<img
			src={image}
			alt="Tassie Tours - Explore Tasmania"
			class="h-screen w-full object-cover dark:brightness-[0.2] dark:grayscale"
		/>
	</div>
</div>
